import React from "react";

const SubsCardShimmer = () => {
  return (
    <div className="max-w-xl w-full mx-auto mt-4">
      {/* MAIN CARD */}
      <fieldset className="border border-gray-200 rounded-xl p-4 relative bg-white">
        {/* LEGEND */}
        <div className="absolute -top-3 left-4 h-5 w-20 rounded-full shimmer"></div>

        {/* Header */}
        <div className="flex justify-between gap-3">
          <div className="flex gap-3">
            {/* Image */}
            <div className="h-12 w-12 rounded-md shimmer"></div>

            {/* Title */}
            <div className="space-y-2">
              <div className="h-3 w-36 shimmer rounded"></div>
              <div className="h-3 w-24 shimmer rounded"></div>
            </div>
          </div>

          {/* Price */}
          <div className="h-4 w-12 shimmer rounded"></div>
        </div>

        {/* Date */}
        <div className="mt-3 h-3 w-40 shimmer rounded"></div>

        {/* Meta */}
        <div className="flex justify-between mt-4">
          <div className="h-3 w-14 shimmer rounded"></div>
          <div className="h-3 w-16 shimmer rounded"></div>
          <div className="h-3 w-16 shimmer rounded"></div>
        </div>

        {/* Meals + Actions */}
        <div className="mt-5 flex justify-between items-center gap-3 flex-wrap">
          {/* Meals consumed pill */}
          <div className="h-6 w-32 shimmer rounded-full"></div>

          {/* Buttons */}
          <div className="flex gap-2">
            <div className="h-7 w-16 shimmer rounded-full"></div>
            <div className="h-7 w-14 shimmer rounded-full"></div>
            <div className="h-7 w-14 shimmer rounded-full"></div>
          </div>
        </div>
      </fieldset>

      {/* FOOTER */}
      <div className="border border-t-0 border-gray-200 rounded-b-xl px-4 py-3 flex justify-between items-center">
        <div className="h-6 w-28 shimmer rounded-full"></div>
        <div className="h-4 w-32 shimmer rounded"></div>
      </div>
    </div>
  );
};

export default SubsCardShimmer;
